// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountSearchCasesDefaultResponse {
    static getAttributeTypeMap() {
        return SiteAccountSearchCasesDefaultResponse.attributeTypeMap;
    }
}
SiteAccountSearchCasesDefaultResponse.discriminator = undefined;
SiteAccountSearchCasesDefaultResponse.additionalProperties = false;
SiteAccountSearchCasesDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<SearchCasesResponseModel>"
    },
];
//# sourceMappingURL=siteAccountSearchCasesDefaultResponse.js.map